import React from "react";
import bg from "../assets/bg1Pc.png";
import particle1 from "../assets/particle1.png";
import particle2 from "../assets/particle2.png";
import particle3 from "../assets/particle3.png";
import particle4 from "../assets/particle4.png";
import mouse from "../assets/mouse.svg";
import styled, { keyframes } from "styled-components";
function Page1Pc() {
  return (
    <MainContainer id="home">
      <Bg src={bg} />
      <Particle1Container>
        <BlurCircle1 />
        <Particle1 src={particle1} />
      </Particle1Container>
      <Particle2 src={particle2} />
      <Particle3 src={particle3} />
      <Particle4Container>
        <BlurCircle2 />
        <Particle4 src={particle4} />
      </Particle4Container>
      <Contents>
        <SubTitle>3D 주얼리 제작 프로모션</SubTitle>
        <Title>
          브랜드만의 컨셉을 담은
          <br />
          주얼리를 생산해보세요
        </Title>
        <Button
          onClick={() => {
            window.open("http://pf.kakao.com/_UCUzG");
          }}
        >
          <ButtonText>카카오톡 상담하기</ButtonText>
        </Button>
      </Contents>
      <BottomAnim>
        <BottomText1>js lap js lap js lap js lap</BottomText1>
        <BottomText2>js lap js lap js lap js lap</BottomText2>
      </BottomAnim>
      <Mouse src={mouse} />
    </MainContainer>
  );
}

export default Page1Pc;
const slide = keyframes`
0% {
  transform: translateX(100%);
}
100% {
  transform: translateX(-100%);
}
`;
const animDown = keyframes`
  0% {
      transform: translateY(0px);
  }
  50% {
      transform: translateY(50px);
  }
  100% {
      transform: translateY(0px);
  }
`;
const animUp = keyframes`
  0% {
      transform: translateY(0px);
  }
  50% {
      transform: translateY(-50px);
  }
  100% {
      transform: translateY(0px);
  }
`;
const animUp2 = keyframes`
  0% {
      transform: translateY(0px) rotate(-29.927deg);;
  }
  50% {
      transform: translateY(-50px) rotate(-29.927deg);;
  }
  100% {
      transform: translateY(0px) rotate(-29.927deg);;
  }
`;
const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
`;
const Bg = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
`;
const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  margin-top: -80px;
`;
const SubTitle = styled.p`
  color: #111;
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 150% */
`;
const Title = styled.p`
  color: #111;
  text-align: center;
  font-family: Pretendard;
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: 78px; /* 130% */
  margin-top: 16px;
`;
const Button = styled.div`
  cursor: pointer;
  display: inline-flex;
  padding: 20px 38px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: #000;
  margin-top: 30px;
`;
const ButtonText = styled.p`
  color: #fff;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
`;
const BottomText1 = styled.p`
  position: absolute;
  bottom: 70px;
  width: 3000px;
  min-width: 150vw;
  color: #fff;
  text-align: left;
  font-family: Pretendard;
  font-size: 200px;
  font-style: normal;
  font-weight: 700;
  line-height: 78px; /* 39% */
  opacity: 0.2;
  word-break: keep-all;
  animation: ${slide} 40s linear infinite;
`;
const BottomText2 = styled(BottomText1)`
  animation-delay: -20s;
`;
const BottomAnim = styled.div`
  display: flex;
  flex-direction: row;
`;
const Particle1Container = styled.div`
  position: absolute;
  left: 10vw;
  top: 18vh;
  animation: ${animUp} 10s ease-in-out infinite;
`;
const Particle1 = styled.img`
  width: 184px;
  height: 174px;
`;
const Particle2 = styled.img`
  position: absolute;
  left: 25vw;
  bottom: 20vh;
  width: 133.256px;
  height: 133.256px;
  animation: ${animUp2} 15s ease-in-out infinite;
`;
const Particle3 = styled.img`
  position: absolute;
  right: 25vw;
  top: 20vh;
  width: 96px;
  height: 96px;
  animation: ${animDown} 20s ease-in-out infinite;
`;
const Particle4Container = styled.div`
  position: absolute;
  right: -10vw;
  bottom: 4vh;
  animation: ${animDown} 12s ease-in-out infinite;
`;
const Particle4 = styled.img`
  width: 500px;
  height: 476px;
`;
const BlurCircle1 = styled.div`
  position: absolute;
  left: 120px;
  top: 40px;
  width: 200px;
  height: 200px;
  border-radius: 100px;
  background: linear-gradient(
    141deg,
    rgba(255, 255, 255, 0.3) 8.72%,
    rgba(255, 255, 255, 0) 100%
  );
  backdrop-filter: blur(25px);
`;
const BlurCircle2 = styled(BlurCircle1)`
  left: auto;
  top: auto;
  right: 320px;
  bottom: 320px;
  width: 288px;
  height: 288px;
  border-radius: 144px;
`;
const Mouse = styled.img`
  position: absolute;
  width: 26px;
  height: 40px;
  bottom: 50px;
  z-index: 1;
`;
